export const pathNames = {
    SAFETYFORMS: "/safety-forms",
    TIMESHEETS: "/time-sheets",
    DAILYREPORT: "/daily-report",
    USERS: "/users",
    SETTINGS: "/settings",
    NOTIFICATIONS: "/notifications",
    NEWPASSWORD: "/new-password",
    ACCESSDENIED: "/access-denied",
    IMAGES: "/images",
};

export const androidFilepath = "https://play.google.com/store/apps/details?id=com.razorsharpconsulting.unitedroofing"